<template>
  <v-container fluid class="pa-0 ma-0 account-locked-container">
    <v-img :src="images.bgLocked" alt="background" class="background-image" cover />
    
    <v-row
      align="center"
      justify="center"
      class="content-row"
    >
      <v-col cols="12" sm="10" md="6" lg="5" xl="4">
        <div class="logo-on-card">
          <img 
            alt="Fusion Logo"
            :src="images.logo"
            style="width: 320px;"
          />
          <div
            class="label-version mr-2">
            {{ versioning != null && versioning != "" ? "Version" : "" }}
            {{ "R" + versioning }}
          </div>
        </div>
        
        <v-card
          class="account-locked-card text-center" style="padding: 20px;"
        >
          <div class="mb-4 mt-6">
            <img src="@/assets/lock-2-line.png" alt="image" width="60" height="60" />
          </div>

          <h3 class="mb-1 text-title">
            We’ve temporarily locked your account for security.
          </h3>
          <p class="text-body mb-8">
            Please contact the support team for help, or return to the login page.
          </p>

          <div class="button-group">
            <v-btn
              class="contact-support-btn"
              @click="contactSupport"
              elevation="0"
            >
              <span>Contact Support</span>
            </v-btn>

            <v-btn
              class="back-login-btn"
              @click="backToLogin"
              elevation="0"
            >
              <span>Back to Login</span>
            </v-btn>
          </div>

        </v-card>
        <p v-if="showSupportText" class="system-msg mt-4">
          Please contact your system administrator for assistance.
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import bgLockedImg from "@/assets/bgLocked.png";
import logoLockedImg from "@/assets/logoLocked.svg";
import logoImg from "@/assets/Group 141.png";
import { useDisplay } from "vuetify";
import { VDataTableGroupHeaderRow } from "vuetify/lib/components/VDataTable/VDataTableGroupHeaderRow";
import { version } from "../../package.json";
export default {
  name: "AccountLocked",
  data() {
    return {
      images: {
        logo: logoImg,
        bgLocked: bgLockedImg,
        logoLocked: logoLockedImg,
      },
      versioning: version,
      showSupportText: false,
    };
  },
  methods: {
    backToLogin() {
      this.$emit("back-to-login");
    },
    contactSupport() {
      this.showSupportText = true;
    },
  },
};
</script>

<style scoped>
.account-locked-container {
  position: relative;
  min-height: 100vh;
  padding: 20px 0;
}

.background-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

.content-row {
  position: relative;
  min-height: 100vh;
  z-index: 5;
  display: flex;
  align-items: center;
}

.logo-on-card {
  display: flex;
  justify-content: center;
  position: relative;
}

.logo-image {
  width: 434px;
  height: 200px;
  max-height: 180px;
}

.account-locked-card {
  border-radius: 12px !important;
  width: 100%;
  max-width: 900px;
  position: relative;
  margin-top: 30px;
}

.text-title {
  color: #000;
  font-size: 19px;
  font-weight: 500;
  line-height: 1.6rem;
}

.text-body {
  color: gray;
  font-size: 14px;
}

.button-group {
  display: flex;
  justify-content: space-evenly;
  margin-bottom: 8px;
}

.contact-support-btn {
  width: 48%;
  height: 42px;
  border-radius: 8px !important;
  background: #ffffff !important;
  border: 1px solid #ff0000 !important;
  text-transform: none;
}
.contact-support-btn span {
  color: #C32E0E;
  font-size: 14px;
  font-weight: 600;
}

.back-login-btn {
  width: 44%;
  height: 42px;
  border-radius: 8px !important;
  color: #ffffff !important;
  background: linear-gradient(90deg, #c32e0e, #f67760) !important;
  text-transform: none;
}
.back-login-btn span {
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
}

.system-msg {
  color: #c32e0e;
  font-weight: 500;
  font-size: 0.95rem;
  text-align: center;
}

.label-version {
  display: flex;
  padding: 6px 12px 4px 12px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  color: var(--main, #C32E0E);
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  border-radius: 24px;
  background: linear-gradient(91deg, rgba(246, 119, 96, 0.10) 1.14%, rgba(195, 46, 14, 0.10) 46.51%, rgba(246, 119, 96, 0.10) 120.41%);
  position: absolute;
  bottom: 7px;
  right: 30px;
}

@media (max-width: 340px) {
  .logo-on-card {
    margin-bottom: -30px;
  }

  .logo-image {
    width: 140px;
    max-height: 60px;
  }

  .account-locked-card {
    margin-top: 12px;
  }

  .text-title {
    font-size: 1.1rem;
  }

  .text-body {
    font-size: 12px;
  }

  .button-group {
    gap: 6px;
    display: flex;
    flex-direction: row;
  }
}
</style>
